<template>
  <div class="main" v-title data-title="洛济-试剂耗材采购库存管理系统">
    <div class="logo-title">
     
      <h2>
        {{ platformInfo.sysName }}
      </h2>
    </div>
    <div class="login-container" v-if="!changePass && visitType == 'login'">
      <div class="login-content">
        <img
         src="../../assets/images/loginLeft.png"
          class="login-left"
          alt=""
        />
        <div class="login-content-sysName">{{ platformInfo.sysName }}</div>
        <div class="login-info">
          <h2>登    {{"\xa0\xa0"}}{{"\xa0\xa0"}}  录</h2>
          <ul>
            <li>
              <label for="登录账号">登录账号</label>
              <input class="accountName" type="text" v-model="accountName" />
            </li>
            <li>
              <label for="密码">密码</label>
              <input :type="pwdType" class="accountName" v-model="password" @keyup.enter="login()"/>
              <img
                :src="
                  seen
                    ? require(`../../assets/images/openeye.png`)
                    : require(`../../assets/images/nopeneye.png`)
                "
                class="eye"
                alt=""
                @click="changeType()"
              />
            </li>
          </ul>
          <div class="card-login" style="display:none;"></div>
          <img src="../../assets/images/card.png" class="card-icon" alt=""  style="display:none;"/>
          <div class="check">
            <el-checkbox v-model="checked">记住密码</el-checkbox>

          </div>
          <el-button type="primary" @click="login()">登录</el-button>
          <div class="check">
            <span><el-link @click="changePass = true">忘记密码?</el-link></span>
            <span class="forget" @click="registerClick()">新用户账号注册</span>
          </div>
        </div>
      </div>
    </div>



    <div class="change-password" v-else-if="changePass && visitType == 'login'">
      <p>确认账号</p>
      <ul>
        <li>
          <label for="登录账号">登录账号</label>
          <input
            type="text"
            v-model="loginName"
            placeholder="请输入登录账号"
          />
        </li>
      </ul>
      <el-button type="primary" @click="getChangePass1()">下一步</el-button>
      <el-button @click="changePass = false" type="warning" class="nomal" style="color:white" >取消</el-button>
    </div>
    <div class="change-password" v-if="changePass1 && visitType == 'loginEdit'">
      <p>修改密码</p>
      <ul>
        <li>
          <!-- <label for="邮箱验证码" style="float:left;">邮箱验证码</label> -->
          <label for="邮箱">&nbsp;&nbsp;&nbsp;{{emialTm}}</label>
          <input
            type="text"
            v-model="changePassInfo.password"
            placeholder="请输入邮箱验证码"
          />
          <span class="tips" v-if="emailZhmm">邮箱验证码已发送</span>
           <div class="check" v-else>
            <span class="forget" @click="getEmailYzm()">获取邮箱验证码</span>
          </div>
        </li>
        <li>
          <label for="新密码">新密码</label>
          <input
            type="password"
            v-model="changePassInfo.newPassword"
            placeholder="请输入新密码（格式：6-16位 字母+数字）"
          />
        </li>
        <li>
          <label for="新密码确认">新密码确认</label>
          <input
            type="password"
            v-model="confirmPassword"
            placeholder="请确认新密码（格式：6-16位 字母+数字）"
          />
        </li>
      </ul>
      <el-button type="primary" @click="changePsd()">确认</el-button>
      <el-button @click="changePass1 = false;visitType='login';changePass = true;" type="warning" class="nomal" style="color:white" >取消</el-button>
    </div>

    <div class="zcBox" v-else-if="visitType == 'registered'">
      <div class="title">注册账号</div>

      <div class="box">
        <div class="normalLine">
          <div class="l_t">注册邀请人</div>
          <div class="r_t">{{ registeredInfo.inviterUser }}</div>
        </div>
        <div class="normalLine">
          <div class="l_t">学校名称</div>
          <div class="r_t">{{ registeredInfo.schoolName }}</div>
        </div>
        <div class="normalLine">
          <div class="l_t">课题组名称</div>
          <div class="r_t">{{ registeredInfo.taskName }}</div>
        </div>
        <div class="input_line">
          <div class="l_t" style="color: #666">真实姓名<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="registeredInfo.nickName"
            type="text"
            placeholder="请输入您的姓名"
          />
        </div>
        <div class="input_line">
          <div class="l_t">登录帐号<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="registeredInfo.accountName"
            type="text"
            placeholder="请设置您的登录账号"
          />
        </div>
        <div class="input_line">
          <div class="l_t">邮箱地址<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="registeredInfo.email"
            type="text"
            placeholder="请输入您的邮箱地址"
          />
        </div>
        <div class="input_line">
          <div class="l_t">手机号<span class="requiedText">*</span></div>
          <input
              class="r_ipt"
              v-model="registeredInfo.cellphone"
              type="text"
              placeholder="请输入您的手机号"
          />
        </div>
        <div class="input_line">
          <div class="l_t">登录密码<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="registeredInfo.password"
            type="password"
            autocomplete="new-password"
            placeholder="请设置您的登录密码"
          />
        </div>
        <div class="input_line">
          <div class="l_t">密码确认<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="registeredInfo.rePassword"
            type="password"
            placeholder="请再次确认您的登录密码"
          />
        </div>
        <div class="input_line">
          <div class="l_t">IC卡号</div>
          <input
              class="r_ipt"
              v-model="registeredInfo.icCard"
              type="text"
              placeholder="请输入您的IC卡号"
          />
        </div>
      </div>
      <button class="cursorPointer" @click="registPsd">确认</button>
    </div>
    <div class="zcBox" v-else-if="visitType == 'otherGroupRegistered'">
      <div class="title">注册账号</div>

      <div class="box">
        <div class="normalLine">
          <div class="l_t">注册邀请人</div>
          <div class="r_t">{{ otherGroupRegisteredInfo.inviterUser }}</div>
        </div>
        <div class="input_line">
          <div class="l_t" style="color: #666">真实姓名<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="otherGroupRegisteredInfo.nickName"
            type="text"
            placeholder="请输入您的姓名"
          />
        </div>
        <div class="input_line">
          <div class="l_t">登录帐号<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="otherGroupRegisteredInfo.accountName"
            type="text"
            placeholder="请设置您的登录账号"
          />
        </div>
        <div class="input_line">
          <div class="l_t">邮箱
            <el-tooltip
                        class="item"
                        effect="light"
                        content="将用于接收注册页面成功通知和找回密码"
                        placement="right-start">
              <i class="el-icon-question" />
            </el-tooltip>
            <span class="requiedText"> *</span></div>
          <input
            class="r_ipt"
            v-model="otherGroupRegisteredInfo.email"
            type="text"
            placeholder="请输入您的邮箱地址"
          />
        </div>
        <div class="input_line">
          <div class="l_t">登录密码<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="otherGroupRegisteredInfo.password"
            type="password"
            autocomplete="new-password"
            placeholder="请设置您的登录密码"
          />
        </div>
        <div class="input_line">
          <div class="l_t">密码确认<span class="requiedText">*</span></div>
          <input
            class="r_ipt"
            v-model="otherGroupRegisteredInfo.rePassword"
            type="password"
            placeholder="请再次确认您的登录密码"
          />
        </div>
        <div class="input_line">
          <div class="l_t">IC卡号</div>
          <input
              class="r_ipt"
              v-model="otherGroupRegisteredInfo.icCard"
              type="text"
              placeholder="请输入您的IC卡号"
          />
        </div>
        <div class="input_line">
          <div class="l_t">手机号<span class="requiedText">*</span></div>
          <input
              class="r_ipt"
              v-model="otherGroupRegisteredInfo.phone"
              type="text"
              placeholder="请输入手机号"
          />
        </div>
      </div>
      <button class="cursorPointer" @click="otherGroupRegistPsd">确认</button>
    </div>
    <!-- 备案号 -->
    <div class="record">洛济化学技术(上海)有限公司 沪ICP备2021028033号-1</div>

  </div>
</template>
<script>
let Base64 = require('js-base64').Base64
export default {

  data() {
    return {
      changePass: false,
      changePass1:false,
      seen: "",
      openeye: "../../assets/images/openeye.png",
      nopeneye: "../../assets/images/nopeneye.png",
      pwdType: "password",
      checked: false,
      accountName: "",
      password: "",
      changePassInfo: {
        password: "",
        newPassword: "",
        accountName: "",
      },
      confirmPassword: "",
      // 登录默认 login  注册 registered
      visitType: "login",
      registeredInfo: {
        inviterUser: "",
        schoolName: "",
        schoolId: "",
        taskId: "",
        taskName: "",
        accountName: "",
        nickName: "",
        password: "",
        rePassword: "",
        icCard: "",
        inviterCode: "",
        inviterId: "",
        email: "",
        cellphone:"",
      },
      otherGroupRegisteredInfo: {
        inviterUser: "",
        schoolName: "",
        schoolId: "",
        taskId: "",
        taskName: "",
        accountName: "",
        nickName: "",
        password: "",
        rePassword: "",
        icCard: "",
        inviterCode: "",
        inviterId: "",
        email: "",
        phone:"",
      },
      platformInfo: "",
      emailZhmm:"",
      loginName:"",
      emialTm:"",
      originEmail:"" // 原邮箱：未脱敏
    };
  },
  created() {
    this.getLoker();
    // if (this.$route.query.params) {
    //   this.visitType = "registered";
    //   if(this.$route.query.type == 1){
    //     this.visitType = "otherGroupRegistered";
    //   }
    //   var data = this.$route.query.params;
    //   var str=data.split(',');
    //   var params = str[0];
    //   params= params.replace(/\s/g, '+');
    //   params = Base64.decode(params);
    //   console.log(params);
    //   let strArray = params.split('&');
    //   console.log(strArray);
    //   //获取邀请信息
    //   // const { schoolName, taskName, accountName, code, visitType } =
    //   //   this.$route.query;
    //
    //   if(this.$route.query.type == 1){
    //     // this.otherGroupRegisteredInfo.schoolName = strArray[2];
    //     // this.otherGroupRegisteredInfo.taskName = strArray[3];
    //     this.otherGroupRegisteredInfo.inviterUser =
    //         strArray[2] + "/" + strArray[3] + "/" + strArray[5];
    //     this.otherGroupRegisteredInfo.inviterCode = strArray[4];
    //     this.otherGroupRegisteredInfo.inviterId = strArray[0];
    //   }
    //   this.registeredInfo.schoolName = strArray[2];
    //   this.registeredInfo.taskName = strArray[3];
    //   this.registeredInfo.inviterUser =
    //       strArray[2] + "/" + strArray[3] + "/" + strArray[5];
    //   this.registeredInfo.inviterCode = strArray[4];
    //   this.registeredInfo.inviterId = strArray[0];
    // }
  },

  // created() {
  //   this.getLoker();
  //   if (this.$route.query.params) {
  //     this.visitType = "registered";
  //     if(this.$route.query.type == 1){
  //       this.visitType = "otherGroupRegistered";
  //     }
  //     var data = this.$route.query.params;
  //     var str=data.split(',');
  //     var params = str[0];
  //     params= params.replace(/\s/g, '+');
  //     params = Base64.decode(params);
  //     console.log(params);
  //     let strArray = params.split('&');
  //     console.log(strArray);
  //     //获取邀请信息
  //     // const { schoolName, taskName, accountName, code, visitType } =
  //     //   this.$route.query;
  //
  //     if(this.$route.query.type == 1){
  //       // this.otherGroupRegisteredInfo.schoolName = strArray[2];
  //       // this.otherGroupRegisteredInfo.taskName = strArray[3];
  //       this.otherGroupRegisteredInfo.inviterUser =
  //           strArray[2] + "/" + strArray[3] + "/" + strArray[5];
  //       this.otherGroupRegisteredInfo.inviterCode = strArray[4];
  //       this.otherGroupRegisteredInfo.inviterId = strArray[0];
  //     }
  //     this.registeredInfo.schoolName = strArray[2];
  //     this.registeredInfo.taskName = strArray[3];
  //     this.registeredInfo.inviterUser =
  //         strArray[2] + "/" + strArray[3] + "/" + strArray[5];
  //     this.registeredInfo.inviterCode = strArray[4];
  //     this.registeredInfo.inviterId = strArray[0];
  //   }
  // },
  mounted() {
    this.getCookie();
  },
  methods: {
    registerClick(){
      this.$router.push({ name: "register"});
    },
    noPassByEmail(email) {
        let new_email = email;
        if (String(email).indexOf('@') > 0) {
            let str = email.split('@');
            let _s = '';
            if (str[0].length > 3) { //@前面多于3位
                for (let i = 3; i < str[0].length; i++) {
                    _s += '*';
                }
                new_email= str[0].substr(0, 3) + _s + '@' + str[1];
            }else{ //@前面小于等于于3位
                for(let i = 1;i<str[0].length;i++){
                    _s+='*'
                }
                new_email = str[0].substr(0,1)+ _s + '@' + str[1]
            }
        }
        return new_email;
    },
    getChangePass1(){
      // debugger;
      if(this.loginName=="" || this.loginName==null){
           this.$message({
              showClose: true,
              message: "请填写登录账号",
              type: "error",
            });
            return;
      }
       let params = {accountName:this.loginName};
      let this_=this;
      this.$apiFetch.get(`/lockerUser/getUserByAccount`, params).then((res) => {
        console.log(res,"res------")
        // debugger;
        let obj= res.data
        this.originEmail = res.data.email
        if(obj==null || obj=="" ||obj.email==""){
             this_.$message({
              showClose: true,
              message: "您填写的账号没有邮箱信息！请联系管理员",
              type: "error",
            });
            return;
        }
        this.emialTm=this.noPassByEmail(obj.email);
         this.changePass1=true;
        this.changePass=false;
        this.visitType="loginEdit";
      });
    },
    getEmailYzm(){
      let params = {email:this.originEmail};
       this.$apiFetch.post(`/lockerUser/sendEmail`,params).then((res) => {
          console.log(res);
          this.emailZhmm=res.data;
      })
      this.$message.success("验证码已发送")
    },
    getLoker() {
      this.$apiFetch
        .get("/lockerCopywriting/list")
        .then((data) => {
          this.platformInfo = data.data[0];
          localStorage.setItem(
            "platformInfo",
            JSON.stringify(this.platformInfo)
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //小眼睛切换
    changeType() {
      this.pwdType = this.pwdType === "password" ? "text" : "password";
      this.seen = !this.seen; //小眼睛的变化
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" +
        "=" +
        escape(c_name) +
        ";path=/;expires=" +
        exdate.toGMTString();
      window.document.cookie =
        "userPwd" +
        "=" +
        escape(c_pwd) +
        ";path=/;expires=" +
        exdate.toGMTString();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.accountName = unescape(arr2[1]); //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.password = unescape(arr2[1]);
          }
        }
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    //登录
    login() {
      //判断复选框是否被勾选 勾选则调用配置cookie方法
      if (this.checked == true) {
        //传入账号名，密码，和保存天数3个参数
        this.setCookie(this.accountName, this.password, 30);
      } else {
        //清空Cookie
        this.clearCookie();
        this.setCookie(this.accountName, "", 30);
      }

      //与后端请求代码，本功能不需要与后台交互所以省略

      const params = {
        accountName: this.accountName,
        password: this.password,
      };
      if (!params.accountName || !params.password) {
        this.$message({
          showClose: true,
          message: "请填写登录账号和密码",
          type: "error",
        });
        return;
      }
      this.$apiFetch.post("lockerUser/loginByUserName", params).then((res) => {
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        } else {
          localStorage.setItem("TOKEN", res.data);
          this.$router.push({ path: "home" });
          // this.$router.push({ path: "guide" });
        }
      });
    },
    //修改密码
    changePsd() {
      // debugger;
      this.changePassInfo.accountName = this.loginName;
      if (!this.loginName) {
        this.$message({
          showClose: true,
          message: "请填写账号",
          type: "error",
        });
        return;
      }
      if (this.changePassInfo.newPassword !== this.confirmPassword) {
        console.log(this.changePassInfo.newPassword, this.confirmPassword);
        this.$message({
          showClose: true,
          message: "两次密码输入不一致",
          type: "error",
        });
        return;
      }
      this.changePassInfo.email = this.originEmail;
      this.changePassInfo.code = this.changePassInfo.password
      let params = this.changePassInfo;
      console.log("params = ",params)
      this.$apiFetch.post("/lockerUser/findPwd", params).then((res) => {
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        } else {
          //清空Cookie
          this.clearCookie();
          this.setCookie(this.accountName, "", 30);
          this.clearInput();
          this.password = ""
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success",
          });
          this.changePass1 = false;
          this.visitType="login";
        }
      });
    },

    // 清除输入框
    clearInput(){
        this.loginName = "";//登录账号
        this.changePassInfo.password = "";//邮箱验证码
        this.changePassInfo.newPassword = "";//新密码
        this.confirmPassword = "";//确认密码
    },

    //
    async checkOtherGroupRegister(){
      const {
        inviterCode,
        accountName,
        nickName,
        password,
        rePassword,
        inviterId,
        email,
        icCard,
        phone,
      } = this.otherGroupRegisteredInfo;
      const params = {
        inviterCode,
        accountName,
        nickName,
        password,
        rePassword,
        inviterId,
        email,
        icCard,
        'cellphone':phone,
      };
      const res =await this.$apiFetch.post("/lockerInvite/registCheck", params)
      return res.data

    },
    //外组注册账号
    async otherGroupRegistPsd(){
      const {
        inviterCode,
        accountName,
        nickName,
        password,
        rePassword,
        inviterId,
        email,
        icCard,
        phone,
      } = this.otherGroupRegisteredInfo;
      const params = {
        'businessType':'Member',
        'realName':nickName,
        'loginMember':accountName,
        'email':email,
        'password':password,
        'reallyPassword':rePassword,
        'phone':phone,
        inviterCode,
        inviterId,
        icCard,
      };

      let errText = ''
      if(!inviterCode) {
        errText = '缺少邀请码'
      }else if(!accountName){
        errText = '缺少登录账号'
      }else if(!nickName){
        errText = '缺少账号名称'
      }else if(!password){
        errText = '缺少登录密码'
      }else if(!rePassword){
        errText = '缺少确认登录密码'
      }else if(!inviterId){
        errText = '缺少邀请人Id'
      }else if(!email){
        errText = '缺少邮箱'
      }else if(!phone){
        errText = '缺少手机号'
      }else if(!phone.match( /^1[3-9]\d{9}$/)){
        errText = "请输入正确手机号"
      }
      else if(password !== rePassword){
        errText = '两次输入密码不同'
      }

      if(errText){
        this.$message({
          showClose: true,
          message: errText,
          type: "error",
        });
        return;
      }

      let flag = await this.checkOtherGroupRegister(params);
      if(flag != true ){
        return;
      }

      this.$apiFetch.post("/lockerInvite/preparationInvite", params).then((res) => {
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        } else {
          localStorage.setItem('businessNo', res.data);
          let params2 = {
            'businessNo':res.data,
            'businessType':'Invite',
            'inviteUserId':inviterId
          }
          this.$apiFetch.post("/lockerInvite/preparationInvite", params2).then((res) => {
            if (res.data.code == 418) {
              this.$message({
                showClose: true,
                message: res.data.description,
                type: "error",
              });
            } else {
              let tempUser = {
                'accountName': accountName,
                'pwd':password,
                'email':email,
                'realName':nickName,
              }
              localStorage.setItem("tempUser",JSON.stringify(tempUser))
              this.$router.push('/register')
            }
          }).catch(err=>{
            this.$message.error("注册失败！")
          });
        }
      }).catch(err=>{
        this.$message.error("注册失败")
      });
    },

    //注册账号
    registPsd() {
      const {
        inviterCode,
        accountName,
        nickName,
        password,
        rePassword,
        inviterId,
        email,
        icCard,
        cellphone,
      } = this.registeredInfo;
      const params = {
        inviterCode,
        accountName,
        nickName,
        password,
        rePassword,
        inviterId,
        email,
        icCard,
        cellphone,
      };

      let errText = ''
      if(!inviterCode) {
        errText = '缺少邀请码'
      }else if(!accountName){
        errText = '缺少登录账号'
      }else if(!nickName){
        errText = '缺少账号名称'
      }else if(!password){
        errText = '缺少登录密码'
      }else if(!rePassword){
        errText = '缺少确认登录密码'
      }else if(!inviterId){
        errText = '缺少邀请人Id'
      }else if(!email){
        errText = '缺少邮箱'
      }else if(!cellphone){
        errText = '缺少手机号'
      }else if(!cellphone.match( /^1[3-9]\d{9}$/)){
        errText = "请输入正确手机号"
      }else if(password !== rePassword){
        errText = '两次输入密码不同'
      }

      if(errText){
         this.$message({
            showClose: true,
            message: errText,
            type: "error",
          });
          return;
      }

      // if (!this.isEmail(email)){
      //   return this.$message.error("请填写正确的邮箱地址");
      // }
      // const values = Object.values(params);
      // console.log(values);
      // for (let i in values) {
      //   if (!values[i]) {
      //     this.$message({
      //       showClose: true,
      //       message: "缺少信息",
      //       type: "error",
      //     });
      //     return;
      //   }
      // }
      this.$apiFetch.post("/lockerUser/regist", params).then((res) => {
        if (res.data.code == 418) {
          this.$message({
            showClose: true,
            message: res.data.description,
            type: "error",
          });
        } else {
          this.$message({
            showClose: true,
            message: `注册成功,您是第${res.data}位注册成功的用户！`,
            type: "success",
          });
          this.visitType = "login";
          // localStorage.setItem('TOKEN', res.data)
          // this.$router.push({ path: 'home' })
        }
      });
    },

    isEmail(val){
      const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/;
      return reg.test(val)
    },
  },
};
</script>
<style lang="less" scoped>
.record {
  position: fixed;
  bottom: 30px;
  text-align: center;
  margin: 0 auto;
  width: 100%;
}
.login-container {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
}
.main {
  background: url("../../assets/images/loginBgc.png") bottom;
  background-color: #f2f5fa;
  min-height: 100vh;
  .logo-title {
    display: flex;
    img {
      width: 24px;
      height: 24px;
      margin: 16px 10px 0 20px;
    }
    h2 {
      height: 32px;
      font-size: 20px;
      font-weight: 700;
      color: #333333;
      line-height: 32px;
      padding-top: 12px;
    }
  }
}
.login-content {
  // width: 1049px;
  // height: 598px;
  width: 54%;
  height: 55%;
  min-width: 840px;
  min-height: 538px;
  box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
  border-radius: 12px;
  overflow: hidden;
  margin: auto auto;
  // margin-top: 140px;
  position: relative;
  img.login-left {
    width: 47.8%;
    min-width: 401px;
    display: block;
    float: left;
    object-fit: cover;
    height: 100%;
  }
  .login-content-sysName {
    position: absolute;
    top: 156px;
    width: 47.8%;
    height: 100%;
    min-width: 401px;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    color: #fff;
    word-break: break-all;
    padding: 0 80px;
  }
  .login-info {
    overflow: hidden;
    padding: 40px 70px;
    position: relative;
    background: #fff;
    height: 100%;
    .accountName {
      color: #333;
    }
    h2 {
      text-align: center;
      font-size: 30px;
      font-weight: 700;
      color: #478aff;
      line-height: 42px;
      letter-spacing: 2px;
      text-shadow: 0px 4px 20px rgba(16, 44, 91, 0.09);
    }

    .el-button {
      width: 100%;
      text-align: center;
      margin-top: 30px;
    }

    .card-login {
      width: 0;
      height: 0;
      border-top: 126px solid #f0f5ff;
      border-left: 126px solid transparent;
      position: absolute;
      top: 0;
      right: 0;
    }
    img.card-icon {
      position: absolute;
      width: 125px;
      display: block;
      top: 0;
      right: 0;
    }
  }
}
.check {
      padding-top: 10px;
      /deep/ .el-checkbox__label {
        color: #666666;
      }
      .forget {
        color: #478aff;
        font-size: 14px;
        line-height: 22px;
        float: right;
        cursor: pointer;
      }
    }
.change-password {
  width: 542px;
  height: 598px;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
  border-radius: 12px;
  padding: 10px 72px;
  margin: 0 auto;
  margin-top: 40px;
  box-sizing: border-box;
  p {
    font-size: 24px;
    font-weight: 700;
    color: #333333;
    line-height: 33px;
    letter-spacing: 2px;
    text-align: center;
  }
  button {
    width: 100%;
    margin-top: 40px;
  }
  .el-button.nomal {
    border: none;
    color: #999999;
    margin: 0;
    margin-top: 10px;
  }
  ul {
    padding-top: 40px;
    li:not(:first-child) {
      margin-top: 30px;
    }
  }
}
ul {
  padding-top: 60px;
  li {
    position: relative;
    label {
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
      letter-spacing: 1px;
      text-shadow: 0px 4px 20px rgba(16, 44, 91, 0.09);
      display: block;
    }
    input {
      border: none;
      border-bottom: 1px solid #102c5b;
      width: 100%;
      height: 45px;
      line-height: 45px;
      color: #cccccc;
      margin-top: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .tips {
      height: 18px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      padding-top: 5px;
    }
    img.eye {
      position: absolute;
      right: 0;
      width: 20px;
      bottom: 14px;
    }
  }
  li:not(:first-child) {
    margin-top: 40px;
  }
}

.zcBox {
  padding: 40px 72px;
  width: 542px;
  //height: 598px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(16, 44, 91, 0.09);
  border-radius: 12px;

  .title {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 33px;
    letter-spacing: 2px;
  }

  .box {
    margin-top: 30px;

    .normalLine {
      display: flex;
      margin-top: 30px;

      .l_t {
        width: 70px;
        height: 20px;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
      }

      .r_t {
        margin-left: 19px;
        flex: 1;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        line-height: 20px;
      }
    }

    .input_line {
      margin-top: 30px;
      border-bottom: 1px solid #999;
      display: flex;
      padding-bottom: 10px;

      .l_t {
        width: 70px;
        height: 20px;
        font-size: 14px;
        color: #333;
        line-height: 20px;
      }

      .r_ipt {
        margin-left: 19px;
        flex: 1;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        line-height: 20px;
      }
    }

    ::-webkit-input-placeholder {
      color: #ccc;
      font-weight: 400;
    }
  }
  .requiedText{
  color: red;
}
  button {
    width: 100%;
    margin-top: 40px;
    height: 48px;
    background: #478aff;
    border-radius: 4px;
    text-align: center;
    line-height: 48px;
    font-size: 18px;
    color: #ffffff;
  }
}
</style>